import { render, staticRenderFns } from "./Advice.vue?vue&type=template&id=1da43474"
import script from "./Advice.vue?vue&type=script&lang=js"
export * from "./Advice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports